document.addEventListener("DOMContentLoaded", function (event) {
	$(".btn-header-toggle").click(function () {
		$(".header-nav").toggleClass("active");
		$(this).children("i").toggleClass("fa-times fa-grip-lines");
		$(".site-header").addClass("active");
		$("body").toggleClass("menu-active");
		$("html, body").scrollTop(0);
	});

	function redirectToSearchDesktop() {
		const query = document.querySelector(".header-desktop-search-input").value;
		window.location.href = `/search?keywords=${encodeURIComponent(query)}`;
	}

	document.querySelector(".header-desktop-search-submit").addEventListener("click", function (event) {
		event.preventDefault();
		redirectToSearchDesktop();
	});

	document.querySelector(".header-desktop-search-input").addEventListener("keydown", function (event) {
		if (event.key === "Enter") {
			event.preventDefault();
			redirectToSearchDesktop();
		}
	});

	function redirectToSearchMobile() {
		const query = document.querySelector(".header-mobile-search-input").value;
		window.location.href = `/search?keywords=${encodeURIComponent(query)}`;
	}

	document.querySelector(".header-mobile-search-submit").addEventListener("click", function (event) {
		event.preventDefault();
		redirectToSearchMobile();
	});

	document.querySelector(".header-mobile-search-input").addEventListener("keydown", function (event) {
		if (event.key === "Enter") {
			event.preventDefault();
			redirectToSearchMobile();
		}
	});

	if (window.innerWidth > 1231) {
		$(".desktop-menu > ul > li > .menu-item").hover(
			function () {
				const $this = $(this);
				if ($this.next(".header-submenu").length > 0) {
					$(".menu-item").not($this).children("i.dropdown-icon").removeClass("fa-chevron-up").addClass("fa-chevron-down");
					$(".menu-item").not($this).next(".header-submenu").removeClass("active");
					$(".menu-item").not($this).removeClass("active");
					$this.addClass("active");
					$this.children("i.dropdown-icon").removeClass("fa-chevron-down").addClass("fa-chevron-up");
					$(".btn-header-search").removeClass("active").children("i").removeClass("fa-times").addClass("fa-search");
					$(".search-menu").removeClass("active");
					$(".get-support-menu").removeClass("active");
					$(".btn-header-support").removeClass("active");
					$this.next(".header-submenu").addClass("active");
					$(".site-header").addClass("active");
				}
			}
		);

		$(".header-submenu:not(.get-support-menu):not(.search-menu)").hover(
			function () {
				$(this).addClass("active").prev(".menu-item").addClass("active").children("i.dropdown-icon").removeClass("fa-chevron-down").addClass("fa-chevron-up");
			},
			function () {
				$(this).removeClass("active").prev(".menu-item").removeClass("active").children("i.dropdown-icon").removeClass("fa-chevron-up").addClass("fa-chevron-down");
			}
		);

		$(".btn-header-support").click(function () {
			$(".menu-item").children("i.dropdown-icon").removeClass("fa-chevron-up");
			$(".menu-item").children("i.dropdown-icon").addClass("fa-chevron-down");
			$(".menu-item").next(".header-submenu").removeClass("active");
			$(".menu-item").removeClass("active");
			$(this).toggleClass("active");
			$(".btn-header-search").removeClass("active").children("i").removeClass("fa-times").addClass("fa-search");
			$(".search-menu").removeClass("active");
			$(".get-support-menu").toggleClass("active");
			$(".site-header").addClass("active");
		});

		$(".btn-header-search").click(function () {
			$(".menu-item").children("i.dropdown-icon").removeClass("fa-chevron-up");
			$(".menu-item").children("i.dropdown-icon").addClass("fa-chevron-down");
			$(".menu-item").next(".header-submenu").removeClass("active");
			$(".menu-item").removeClass("active");
			$(".btn-header-support").removeClass("active");
			$(this).toggleClass("active").children("i").toggleClass("fa-times fa-search");
			$(".get-support-menu").removeClass("active");
			$(".search-menu").toggleClass("active");
			$(".site-header").addClass("active");
		});
	}

	if (window.innerWidth < 1232) {
		$(".menu-item").click(function () {
			$(this).next(".header-submenu").addClass("active");
		});

		$(".btn-header-support").click(function () {
			$(".get-support-menu").addClass("active");
		});

		$(".back-btn").click(function () {
			$(".header-submenu").removeClass("active");
			$(".get-support-menu").removeClass("active");
		});
	}
});
